import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { isCreditCardExistSelector, isLoadingSelector } from '../../../../redux/api-settings/api-settings.selectors';
import { PublicApiPayment } from './public-api-payment';
const mapStateToProps = createStructuredSelector({
  isCreditCardExist: isCreditCardExistSelector,
  isLoading: isLoadingSelector
});
export const AccountApiPayment = connect(mapStateToProps)(PublicApiPayment);